import React from "react";
import Navbar from "../../components/navbar/Navbar";
import NewCustomer from "../../components/customers/NewCustomer";
import { useLocation } from "react-router-dom";

const NewCustomerPage = () => {
  const { state } = useLocation();
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              {state?.id ? (
                <Navbar content="EDIT CUSTOMER" />
              ) : (
                <Navbar content="NEW CUSTOMER" />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              <NewCustomer />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default NewCustomerPage;
